import React, { useState } from 'react';
import { Card } from './Card';
import { HistoricalMenu } from '../historical/HistoricalMenu';
import { TimeLapse } from '../../model/TimeLapse';
import { AnalyticType } from '../../model/AnalyticType';
import { HistoricalChart } from '../historical/HistoricalChart';
import { Filter } from '../../model/Filter';
import { ISaleService } from '../../services/ISaleService';

const HistoricalCard = ({ filter, shared, saleService }: Props) => {
  const [timeLapse, setTimeLapse] = useState(TimeLapse.hours);
  const [primaryOption, setPrimaryOption] = useState(AnalyticType.traffic);
  const [secondaryOption, setSecondaryOption] = useState<AnalyticType | undefined>(undefined);

  const onSelectTimeLapse = (timeLapse: string) => {
    setTimeLapse(timeLapse as TimeLapse);
  }

  const onChangeOptions = (primaryOption: AnalyticType, secondaryOption?: AnalyticType) => {
    setPrimaryOption(primaryOption);
    setSecondaryOption(secondaryOption);
  }

  return (
    <Card className="">
      <div className="card-body">
        <div className="d-flex align-items-center mb-4">
          <h5 className="card-title flex-grow-1 text-start">Historical</h5>
          <div className="btn-group">
            <button type="button" className="btn btn-label-secondary text-dark">
              {timeLapse}
            </button>
            <button type="button" className="btn btn-label-secondary dropdown-toggle dropdown-toggle-split text-black" data-bs-toggle="dropdown" aria-expanded="false">
            </button>
            <ul className="dropdown-menu">
              {
                Object.values(TimeLapse).map(option =>
                  <li key={option}>
                    <span className={`dropdown-item ${option === timeLapse ? 'active' : ''}`} onClick={() => onSelectTimeLapse(option)}>{option}</span>
                  </li>
                )
              }
            </ul>
          </div>
        </div>
        <div className="row">
          <div className={`col-3 order-2 ${shared ? 'col-lg-12 order-lg-1' : 'order-2'}`}>
            <HistoricalMenu onChange={onChangeOptions} />
          </div>
          <div className={`col-9 order-1 ${shared ? 'col-lg-12 order-lg-2 mt-3' : 'order-1'}`}>
            <HistoricalChart primaryOption={primaryOption} secondaryOption={secondaryOption} timeLapse={timeLapse} filter={filter} saleService={saleService} />
          </div>
        </div>
      </div>
    </Card>
  );
}

interface Props {
  filter: Filter,
  shared: boolean,
  saleService: ISaleService
}

export { HistoricalCard };